<script>
    import DialogButton from "../../dialog/components/dialog-button.vue";
    import ConfirmDialog from "../../dialog/confirm-dialog.vue";
    import {
        translations
    } from "../../administration/user/data/variables";

    const DEBUG = false;

    export default {
        name: "wizard-footer",
        components: {ConfirmDialog, DialogButton},
        props: {
            currentStep: Number,
            steps: Array,
            invalid: Boolean,
            invalidProperties: Array,
            processing: Boolean,
            addMode: Boolean,
            errored: Boolean,
        },
        data() {
            return {
                showConfirmCancelDialog: false
            }
        },
        computed: {
            translations() {
                return translations;
            },
            lastStep() { return this.steps.length - 1; },
            firstStep() { return 0; },
            nextToLastStep() { return this.steps.length - 2; },
            invalidPropertiesTooltip() {
                if (!this.invalidProperties) return null;
                if (!this.invalidProperties.length) return null;

                const properties = this.invalidProperties.join(', ');
                return Lang.langGet('Invalid properties: :props', {props: properties});
            },
            isDisabled() {
                if (DEBUG) {
                    console.log(`[DEBUG ONLY] Forcing save enabled!`);
                    return false;
                }
                return this.isLastStep() || this.invalid || this.processing;
            }
        },
        methods: {
            isFirstStep() { return this.currentStep === this.firstStep; },
            isLastStep() { return this.currentStep === this.lastStep; },
            isNextToLastStep() { return this.currentStep === this.nextToLastStep; },
            handleSave() {
                this.$emit('stepping', this.currentStep + 1);
                this.$emit('save');
            },
            handleRestart() {
                this.$emit('stepping', this.firstStep)
                this.$emit('restart');
            },
            handleRetry() {
                this.$emit('stepping', 0);
                this.$emit('restart', true);
            },
            handleClose() {
                if (this.processing) return;

                if (!this.isLastStep()) {
                    this.showConfirmCancelDialog = true;
                } else {
                    this.$emit('close');
                }
            }
        }
    }
</script>

<template>
    <div class="pa-4">
        <div class="d-flex w-100 justify-space-between px-0">
            <div v-if="addMode">
                <dialog-button :disabled="processing"
                    class="mr-1"
                    @click="handleRestart"
                    color="secondary"
                >
                    <i :class="`actionbar-icon mr-1 fa-light fa-rotate-right fa-lg`" />
                    {{isLastStep() ? translations.t_createNew : translations.t_clear}}
                </dialog-button>
                <dialog-button v-if="errored"
                   class="mr-1"
                   @click="handleRetry"
                >
                    <i :class="`actionbar-icon mr-1 fa-light fa-arrows-rotate fa-lg`" />
                    {{translations.retry}}
                </dialog-button>
            </div>
            <div v-else style="width: 1px" />
            <div class="d-flex flex-column">
                <div class="h-100 d-flex align-end">
                    <dialog-button
                        class="mr-1"
                        :disabled="isFirstStep() || isLastStep() || invalid"
                        color="secondary"
                        @click="$emit('stepping', currentStep - 1)"
                    >
                        <i :class="`actionbar-icon mr-1 fa-light fa-caret-left fa-fw fa-lg`" />
                        {{ translations.t_previous }}
                    </dialog-button>
                    <dialog-button v-if="currentStep < nextToLastStep"
                        :tooltip="invalidPropertiesTooltip"
                        class="mr-1"
                        :disabled="isLastStep() || isNextToLastStep() || invalid"
                        color="primary"
                        @click="$emit('stepping', currentStep + 1)"
                    >
                        {{ translations.t_next }}
                        <i :class="`actionbar-icon ml-1 fa-light fa-caret-right fa-fw fa-lg`" />
                    </dialog-button>
                    <dialog-button v-else
                        :tooltip="invalidPropertiesTooltip"
                        class="mr-1"
                        :disabled="isDisabled"
                        color="primary"
                        @click="handleSave"
                    >
                        <i :class="`actionbar-icon mr-1 fa-light fa-floppy-disk fa-fw fa-lg`" />
                        {{ translations.t_save }}
                    </dialog-button>
                    <dialog-button
                        @click="handleClose"
                        :disabled="processing"
                        color="secondary"
                    >
                        <confirm-dialog v-if="showConfirmCancelDialog"
                            :title="`${addMode ? translations.dialogCancelTitleCreate : translations.dialogCancelTitleEdit}`"
                            :message="`${addMode ? translations.dialogCancelMessageCreate : translations.dialogCancelMessageEdit}`"
                            :showDialog="showConfirmCancelDialog"
                            @cancel="() => showConfirmCancelDialog = false"
                            @confirm="$emit('close')"
                            :no-icons="true"
                        />
                        <i :class="`actionbar-icon mr-1 fa-light fa-xmark fa-fw fa-lg`" />
                        {{ translations.t_close }}
                    </dialog-button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .actionbar-icon {
        margin-bottom: -2px;
    }
</style>
